import { EventStatus, EventType } from "@/types";
import { formatDate, getDisplayFilters, keepObjectWithKeys } from "@/utils";
import { Button, Chip, Stack } from "@mui/material";
import { FC } from "react";
import { useListContext } from "react-admin";
import { EventsListFilter } from "../../types";

const FiltersList: FC = () => {
  const { filterValues, setFilters } = useListContext();

  const displayFilters = getDisplayFilters<EventsListFilter>(
    filterValues,
    {
      statuses: {
        [EventStatus.ACTIVE]: "Active",
        [EventStatus.CANCELLED]: "Cancelled",
      },
      types: {
        [EventType.AFFAIR]: "Event",
        [EventType.DATE_NIGHT]: "Date Night",
      },
      fromDate: (value) => "From: " + formatDate(value ?? ""),
      toDate: (value) => "To: " + formatDate(value ?? ""),
    },
    setFilters
  );

  return (
    <Stack direction={"row"} spacing={0.5} alignItems={"center"}>
      {displayFilters.map(({ id, label, onDelete }) => (
        <Chip
          key={id}
          size="small"
          variant="filled"
          label={label}
          onDelete={onDelete}
        />
      ))}
      {!!Object.values(
        keepObjectWithKeys(filterValues as EventsListFilter, [
          "statuses",
          "types",
          "fromDate",
          "toDate",
        ])
      ).length && (
        <Button
          size="small"
          variant="outlined"
          onClick={() => setFilters({}, [])}
        >
          Clear All
        </Button>
      )}
    </Stack>
  );
};

export { FiltersList };
